import ko from "knockout";

import CollapsableText from "./CollapsableText";
import template from "./collapsable-text.html";
import "./collapsable-text.less";

ko.components.register("collapsable-text", {
    viewModel: CollapsableText,
    template: template,
});
